import type { VerificationsCreateParams } from "@/react/api/paywallCheckoutApi.types";
import { absolutePath } from "../../../absolutePath";

export const paywallCheckoutVerifications = {
  create: (params: VerificationsCreateParams) =>
    absolutePath(`paywalls/checkout/verifications/`, { ...params }),
};
